const en_US = {
  builder_btn: 'Builder',
  query_btn: 'Execute',
};
export default en_US;
